import React from 'react'

function CenteredTitle() {
  return <h2 className="ai-sub-landing__title cgt-heading-500">Created with CGTrader AI</h2>
}

export default CenteredTitle
